import { User, UserWithDepartments } from '../users'
import { KindType, ObjectCategory, ObjectType, WorkObject } from '../objects'
import { Overwrite, PickByValue, UnionToIntersection } from 'utility-types'
import { Department, Departments, DepartmentWithUsers } from '../departments'
import {Bool, ID} from 'ts/types/UtilityTypes'

export interface AbstractColumn<Keys, Type = 'text'> {
    name: string,
    key: Keys,
    hide?: boolean,
    required?: boolean,
    type: Type,
}

export type RefKey =
    | 'client'
    | 'work-object'
    | 'work-object-category'
    | 'work-object-type'
    | 'manager'
    | 'brand'
    | 'task-type'
    | 'direction'
    | 'work-type'
    | 'country'
    | 'network'
    | 'department'
    | 'config'

export interface Country {
    id: number,
    code: string
}

export interface WorkType {
    id: number,
    name: string,
    code: string,
    counter: number,
    hidden: number,
}

export const EMPTY_WORK_TYPE: WorkType = {
    code: '', id: 0, name: '', counter: 0, hidden: 0
}

export interface Network {
    id: number,
    name: string,
}

export const EMPTY_NETWORK: Network = {
    id: 0, name: ''
}

export const kindToString = (kind: KindType): string => {
    switch (kind) {
        case KindType.DESIGN:
            return 'Дизайн'
        case KindType.PRODUCTION:
            return 'Производство'
    }
}

export interface Brand {
    id: number,
    title: string,
}

export const EMPTY_BRAND: Brand = {
    id: 0, title: ''
}

export interface Direction {
    id: number,
    title: string,
}
export interface DirectionWithDepartments extends Direction {
    departments: Departments[]
}

export const EMPTY_DIRECTION: Direction = {
    id: 0, title: ''
}

export interface AbstractColumn<Keys> {
    name: string,
    key: Keys,
    hide?: boolean,
    required?: boolean,
}

export interface Client {
    id: number,
    short_title: string,
    folder: string,
}

export interface ClientWithBrands extends Client {
    brands: Brand[],
}

export const EMPTY_CLIENT: ClientWithBrands = {
    id: 0, short_title: '', folder: '', brands: []
}

export enum KindStatus {
    IN_WORK = 0,
    SUCCESS = 1,
    FAILED = 2,
}

export interface DefaultTaskUser {
    id: ID,
    work_type: WorkType | undefined,
    user: User | undefined
}
export const EMPTY_DEFAULT_TASK_USER: DefaultTaskUser = {
    id: -1,
    work_type: undefined,
    user: undefined
}
export interface TaskType {
    id: number,
    name: string,
    folder?: string,
    kind: KindType,
    departments?: Departments[],
    kind_status_id: KindStatus,
    short_name?: string,
    color?: string,
    can_tendered: Bool,
    keep_files: Bool,
    checklist?: string,
    executors?: DefaultTaskUser[]

}

export interface Config {
    id: number,
    key: string,
    name: string,
    value: string,
}

export const EMPTY_TASK_TYPE: TaskType = {
    id: 0,
    name: '',
    kind: KindType.DESIGN,
    kind_status_id: KindStatus.IN_WORK,
    can_tendered: 0,
    keep_files: 0,
    departments: [],
    executors: []
}

export type NormalizedDepartment = Overwrite<DepartmentWithUsers, {
    users: User[],
}>

export type RefUnion = Country | WorkType | Network | WorkObject | ObjectCategory | ObjectType | Brand | Direction |
    ClientWithBrands | TaskType | UserWithDepartments | Department | Departments | DepartmentWithUsers | DirectionWithDepartments | DefaultTaskUser | {work_object?: WorkObject}

export type RefIntersection = UnionToIntersection<RefUnion>

export type RefKeys = keyof RefIntersection

export interface Ref {
    name: string,
    key: RefKey,
    editable?: boolean,
    appendable?: boolean,
    update_only?: boolean,
    category?: string,
    otherLinks?: string[],
    columns: AbstractColumn<keyof PickByValue<RefIntersection, string | number | undefined>,
        'text' | 'number' | 'boolean'>[],
}